// extracted by mini-css-extract-plugin
export default {"Stat":"styles_Stat__c4DTl","value":"styles_value__nQj0b","hasData":"styles_hasData__0+kaO","label":"styles_label__r6QYO","note":"styles_note__5bEWS"};